import { Table, TableContainer, Th, Thead } from '@chakra-ui/react';
import { HeadingPages } from '../../../components/HeadingPages';
import { user } from '../../../helpers/user';
import { Layout } from '../../../components/Layout';
import { ListLayout } from './ListLayout';
import { api } from '../../../services/api';
import { useQuery } from 'react-query';
import { format } from 'date-fns';

const getLayoutSeller = async (idVendedor) => {
  const response = await api.get(`/site/v2/fluxo-layout/listar-fila-layouts/${idVendedor}`);

  return response.data.map((item) => {
    return {
      ...item,
      data_solicitacao: item.data_solicitacao
        ? format(new Date(item.data_solicitacao), 'dd/MM/yyyy HH:mm')
        : 'Sem data',
      nome_produto: item.nome_produto ? item.nome_produto.toLowerCase() : 'Sem nome',
      tipo_personalizacao: item.tipo_personalizacao
        ? item.tipo_personalizacao.toLowerCase()
        : 'Sem tipo',
      cor: item.cor ? item.cor.toLowerCase() : 'Sem cor'
    };
  });
};

export const MeusLayouts = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['layouts', user.codigo_vendedor],
    queryFn: () => getLayoutSeller(user.codigo_vendedor),
    // queryFn: () => getLayoutSeller(2),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5
  });

  return (
    <>
      <HeadingPages name="Meus Layouts" />
      <Layout maxW="1300px">
        <TableContainer>
          <Table>
            <Thead>
              <Th>N. Pedido</Th>
              <Th>Cod. Prod</Th>
              <Th>Dt. Solicitação</Th>
              <Th>Produto</Th>
              <Th>Cor</Th>
              <Th>Personalização</Th>
              <Th>Tipo</Th>
              <Th>Link</Th>
              <Th />
            </Thead>
            {isLoading && (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center' }}>
                  Carregando seus layouts...
                </td>
              </tr>
            )}
            <ListLayout layouts={data} />
          </Table>
        </TableContainer>
      </Layout>
    </>
  );
};
